import { render, staticRenderFns } from "./removeWarehouse.vue?vue&type=template&id=4ceedf38&scoped=true&"
import script from "./removeWarehouse.vue?vue&type=script&lang=js&"
export * from "./removeWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./removeWarehouse.vue?vue&type=style&index=0&id=4ceedf38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceedf38",
  null
  
)

export default component.exports